import { Floor } from "../models/indoor-management";
import { IndoorFloor } from "../../../indoor-maps/models/indoor-maps.model";

export interface IndoorManagementInitialState {
    selectedCompany: string | null;
    floors: Floor[],
    selectedFloor: Floor | null;
    indoorFloors?: IndoorFloor[];
}

const initialIndoorManagementState: IndoorManagementInitialState = {
    selectedCompany: null,
    floors: [],
    selectedFloor: null,
    indoorFloors: []
}

export default initialIndoorManagementState